import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import Modal from 'react-modal';
import { useLocation } from 'react-router-dom';
import { addPointTable, deletePoints, editPoints, getSpeciePoints } from '../store/featureActions';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: "30%",
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "0px",
        padding: "0px",
    },
};
Modal.setAppElement('#root');
const Points = () => {
    const [id, setId] = useState()
    const dispatch = useDispatch()
    const [pointList, setPointList] = useState(null)
    const [detail, setDetail] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState()
    const [startingWeight, setStartingWeight] = useState()
    const [endingWeight, setEndingWeight] = useState()
    const [startingSize, setStartingSize] = useState()
    const [endingSize, setEndingSize] = useState()
    const [points, setPoints] = useState()
    const location = useLocation()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    function viewModal(item, type) {
        setIsOpen(true);
        if (type == "detail") {
            setDetail(item)
        } else if (type == "create") {
            setId(item)
        } else if (type == "delete") {
            setId(item)
        } else if (type == "edit") {
            setDetail(item)
            setId(item?._id)
        }
        setModalType(type)
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
        setPoints()
        setEndingSize()
        setEndingWeight()
        setStartingSize()
        setStartingWeight()
    }

    const pointDelete = async (id) => {
        try {
            let payload = {
                params: id,
                isToast: true
            }
            await dispatch(deletePoints(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            try {
                pointsList()
            } catch (rejectedValueOrSerializedError) {
                console.log(rejectedValueOrSerializedError)
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const pointsEdit = async () => {
        try {
            let payload = {
                body: {
                    startingWeight, endingWeight, startingSize, endingSize, points
                },
                params: id,
                isToast: true
            }
            await dispatch(editPoints(payload)).unwrap()
            setIsOpen(false)
            setPoints()
            setEndingSize()
            setEndingWeight()
            setStartingSize()
            setStartingWeight()
            $('#tableData')
                .DataTable().destroy();
            try {
                pointsList()
            } catch (rejectedValueOrSerializedError) {
                console.log(rejectedValueOrSerializedError)
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const AddPoints = async () => {
        try {
            let payload = {
                body: {
                    startingWeight, endingWeight, startingSize, endingSize, points
                },
                params: location?.state._id,
                isToast: true
            }
            await dispatch(addPointTable(payload)).unwrap()
            setIsOpen(false)
            setPoints()
            setEndingSize()
            setEndingWeight()
            setStartingSize()
            setStartingWeight()
            if (pointList) {
                $('#tableData')
                    .DataTable().destroy();
            }
            pointsList()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const pointsList = async () => {
        try {
            setPointList(null)
            let payload = {
                params: location?.state._id,
                isToast: false
            }
            const response = await dispatch(getSpeciePoints(payload)).unwrap()
            setPointList(response?.data?.points)
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            pointsList();
        }
        return () => {
            mount = false
        }
    }, [])
    useEffect(() => {
        if (pointList) {
            $('#tableData')
                .DataTable({
                    lengthMenu: [10, 25, 50, 100, 200],
                    language: {
                        "emptyTable": "Point Table Not Found"
                    },
                    destroy: true,
                });
        }
    }, [pointList])
    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Change Password"
            >
                <div className='change-password-modal' id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
                    {modalType == "detail" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Image</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <p > <b>Image:</b> {detail?.image.length > 0 ? <><img height="20%" width="20%" style={{ borderRadius: 5 }} src={detail?.image[0]}></img></> : <>No Image Found</>}</p>
                        </div>
                    </> : modalType == "create" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Add Points</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Starting Weight</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Starting Weight" value={startingWeight} onChange={(e) => setStartingWeight(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Ending Weight</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Ending Weight" value={endingWeight} onChange={(e) => setEndingWeight(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Starting Size</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Starting Size" value={startingSize} onChange={(e) => setStartingSize(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Ending Size</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Ending Size" value={endingSize} onChange={(e) => setEndingSize(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Points</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Points" value={points} onChange={(e) => setPoints(e.target.value)} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={AddPoints}>Create</button>
                        </div>
                    </> : modalType == "edit" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Edit Points</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Starting Weight</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Starting Weight" value={startingWeight} defaultValue={detail?.startingWeight} onChange={(e) => setStartingWeight(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Ending Weight</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Ending Weight" defaultValue={detail?.endingWeight} value={endingWeight} onChange={(e) => setEndingWeight(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Starting Size</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Starting Size" value={startingSize} defaultValue={detail?.startingSize} onChange={(e) => setStartingSize(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Ending Size</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Ending Size" value={endingSize} defaultValue={detail?.endingSize} onChange={(e) => setEndingSize(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-75">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="inputGroup-sizing-sm">Points</span>
                                </div>
                                <input type="text" className="form-control" aria-label="Points" value={points} defaultValue={detail?.points} onChange={(e) => setPoints(e.target.value)} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={pointsEdit}>Update</button>
                        </div>
                    </> : modalType == "delete" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Delete Reel Ed Confirmation</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                    <div className="login-button mt-2" style={{ width: "40%" }}>
                                        <button type="button" onClick={() => pointDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Delete</button>
                                    </div>
                                    <div className="login-button mt-2" style={{ width: "40%" }} >
                                        <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </> : <></>}
                </div>
            </Modal>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: pointList ? "3%" : "12%"
            }}>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className=" mt-2 mb-3 d-flex justify-content-end">
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")} >Add Points
                            </button>
                        </div>
                    </div>
                </section>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="tableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                                <thead>
                                                    {pointList ? (<tr>
                                                        <th>S.No</th>
                                                        <th>Starting Weight</th>
                                                        <th>Ending Weight </th>
                                                        <th>Starting Size</th>
                                                        <th>Ending Size</th>
                                                        <th>Points</th>
                                                        <th>Action</th>
                                                    </tr>) : (<tr></tr>)}
                                                </thead>
                                                <tbody >
                                                    {pointList?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item?.startingWeight}</td>
                                                            <td>{item?.endingWeight ? item?.endingWeight : "Infinite"}</td>
                                                            <td>{item?.startingSize}</td>
                                                            <td>{item?.endingSize ? item?.endingSize : "Infinite"}</td>
                                                            <td>{item?.points}</td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}  ><i className="fa fa-solid fa-edit"></i> Edit</span>
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}  ><i className="fas fa-trash-alt"></i> Delete</span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                                {!pointList ?
                                                    status == "loading" || error ? <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot> : <></> : <></>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </>
    )
}
export default Points
